import { useCallback, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { handleGetTmpToken, handleSetToken } from "../Share/Func/Storage";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate } from "react-router-dom";
import { CallApiAdminVerify } from "../Api/Enforcement";
import { adminHome } from "../Api/SubUrl";
import { ShowCustomErrorModal } from "../Components/Atoms/CustomErrorModal";
export const useAdminVerifyPage = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const verifySchemaForm = yup.object().shape({
    code: yup.string().required("Vui lòng nhập mã xác nhận"),
  });

  const { control, handleSubmit } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: useMemo(
      () => ({
        code: "",
        token: handleGetTmpToken(),
      }),
      []
    ),
    resolver: yupResolver(verifySchemaForm),
  });

  const handleVerify = useCallback(
    async (formData) => {
      setLoading(true);

      CallApiAdminVerify(formData, (res) => {
        setLoading(false);
        if (res.Status !== undefined) {
          ShowCustomErrorModal({
            message: res.Status.data,
            title: "Xác thực không thành công",
          });
        } else {
          handleSetToken(res.AccessToken);
          navigate(adminHome);
        }
      });
    },
    [setLoading, navigate]
  );

  const handleInvalid = useCallback((errors) => {
    const errorMessages = Object.values(errors)
      .map((err) => `<p>${err.message}</p>`)
      .join("");
    ShowCustomErrorModal({ message: errorMessages });
  }, []);

  return {
    control,
    loading,
    handleSubmit: handleSubmit(handleVerify, handleInvalid),
  };
};
